module.exports = __webpack_public_path__ + "img/visuel5.eeff4197.jpg";